import colors from '@/config/colors';

// Defines the visual appearance of any shapes the user
// draws.
//
// Does not affect the base layer appearance.
export default [
	// ACTIVE (being drawn)
	// line stroke
	{
		"id": "gl-draw-line",
		"type": "line",
		"filter": [
			"all",
			[ "==", "$type", "LineString" ],
			[ "!=", "mode", "static" ],
		],
		"layout": {
			"line-cap": "round",
			"line-join": "round",
		},
		"paint": {
			"line-color": colors.main,
			"line-dasharray": [ 0.2, 2 ],
			"line-width": 2,
		},
	},

	// polygon fill
	{
		"id": "gl-draw-polygon-fill",
		"type": "fill",
		"filter": [
			"all",
			[ "==", "$type", "Polygon" ],
			[ "!=", "mode", "static" ],
		],
		"paint": {
			"fill-color": colors.primary,
			"fill-outline-color": colors.primary,
			"fill-opacity": 0.1,
		},
	},

	// polygon mid points
	{
		'id': 'gl-draw-polygon-midpoint-halo',
		'type': 'circle',
		'filter': [
			'all',
			[ '==', '$type', 'Point' ],
			[ '==', 'meta', 'midpoint' ],
		],
		'paint': {
			'circle-radius': 5,
			'circle-color': colors.white,
		},
	},
	{
		"id": "gl-draw-polygon-midpoint",
		"type": "circle",
		"filter": [
			"all",
			[ "==", "$type", "Point" ],
			[ "==", "meta", "midpoint" ],
		],
		"paint": {
			"circle-radius": 3,
			"circle-color": colors.primary,
		},
	},

	// polygon outline stroke
	// This doesn't style the first edge of the polygon, which uses the line stroke styling instead
	{
		"id": "gl-draw-polygon-stroke-active",
		"type": "line",
		"filter": [
			"all",
			[ "==", "$type", "Polygon" ],
			[ "!=", "mode", "static" ],
		],
		"layout": {
			"line-cap": "round",
			"line-join": "round",
		},
		"paint": {
			"line-color": colors.main,
			"line-dasharray": [ 0.2, 2 ],
			"line-width": 2,
		},
	},

	// vertex point halos
	{
		"id": "gl-draw-polygon-and-line-vertex-halo-active",
		"type": "circle",
		"filter": [
			"all",
			[ "==", "meta", "vertex" ],
			[ "==", "$type", "Point" ],
			[ "!=", "mode", "static" ],
		],
		"paint": {
			"circle-radius": 7,
			"circle-color": colors.white,
		},
	},

	// vertex points
	{
		"id": "gl-draw-polygon-and-line-vertex-active",
		"type": "circle",
		"filter": [
			"all",
			[ "==", "meta", "vertex" ],
			[ "==", "$type", "Point" ],
			[ "!=", "mode", "static" ],
		],
		"paint": {
			"circle-radius": 5,
			"circle-color": colors.main,
		},
	},

	// INACTIVE (static, already drawn)
	// line stroke
	{
		"id": "gl-draw-line-static",
		"type": "line",
		"filter": [
			"all",
			[ "==", "$type", "LineString" ],
			[ "==", "mode", "static" ],
		],
		"layout": {
			"line-cap": "round",
			"line-join": "round",
		},
		"paint": {
			"line-color": colors.black,
			"line-width": 3,
		},
	},

	// polygon fill
	{
		"id": "gl-draw-polygon-fill-static",
		"type": "fill",
		"filter": [
			"all",
			[ "==", "$type", "Polygon" ],
			[ "==", "mode", "static" ],
		],
		"paint": {
			"fill-color": colors.black,
			"fill-outline-color": colors.black,
			"fill-opacity": 0.1,
		},
	},

	// polygon outline
	{
		"id": "gl-draw-polygon-stroke-static",
		"type": "line",
		"filter": [
			"all",
			[ "==", "$type", "Polygon" ],
			[ "==", "mode", "static" ],
		],
		"layout": {
			"line-cap": "round",
			"line-join": "round",
		},
		"paint": {
			"line-color": colors.black,
			"line-width": 3,
		},
	},
];
